<template>
    <div class="origins-container">
        <!-- SearchBar -->
        <div class="search-section">
            <el-row :gutter="10" class="search-row">
                <el-col :span="8">
                    <el-input 
                        placeholder="Search Origin" 
                        v-model="searchKeyword" 
                        @clear="handleSearch()"
                        @keyup.enter.native="handleSearch()"
                        clearable
                        size="medium">
                        <el-button slot="append" icon="el-icon-search" @click="handleSearch()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="adding" size="medium">
                        <i class="el-icon-plus"></i> 新增
                    </el-button>
                </el-col>
            </el-row>
        </div>

        <!-- Table -->
        <div class="table-container">
            <el-table 
                :data="originList" 
                border 
                stripe
                class="custom-table"
                style="width: 100%">
                <el-table-column type="index" label="#" width="40" align="center"></el-table-column>
                <el-table-column prop="name" label="名称" align="center"></el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="160" align="center"></el-table-column>
                <el-table-column prop="updated_at" label="更新时间" width="160" align="center"></el-table-column>
                <el-table-column label="操作" width="220" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="success" size="small" @click="editing(scope.row)">
                            <i class="el-icon-edit"></i> 编辑
                        </el-button>
                        <el-popconfirm 
                            class="ml-5" 
                            confirm-button-text='确定' 
                            cancel-button-text='我再想想' 
                            icon="el-icon-info" 
                            icon-color="red" 
                            title="确定删除？" 
                            @confirm="deleting(scope.row.id)">
                            <el-button type="danger" size="small" slot="reference">
                                <i class="el-icon-remove-outline"></i> 删除
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            
            <!-- Pagination -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        
        <!-- Edit Dialog -->
        <el-dialog 
            :title="form.id ? '编辑Origin' : '新增Origin'" 
            :visible.sync="dialogFormVisible" 
            :width="'30%'"
            class="custom-dialog"
            :fullscreen="false"
            :close-on-click-modal="false"
            custom-class="mobile-dialog">
            <el-form label-width="90px" size="small" class="edit-form" :model="form" :rules="formRules" ref="form">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入Origin名称" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editCancel">取 消</el-button>
                <el-button type="primary" @click="editDone">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { formatDateTime } from '@/utils/timeUtil';

export default {
    name: 'Origins',
    data() {
        return {
            originList: [],
            dialogFormVisible: false,
            form: {},
            searchKeyword: '',
            formRules: {
                name: [
                    { required: true, message: '请输入Origin名称', trigger: 'blur' }
                ]
            },
            currentPage: 1,
            pageSize: 20,
            total: 0
        }
    },
    created() {
        this.getOrigins()
    },
    methods: {
        handleSearch() {
            this.currentPage = 1
            this.getOrigins()
        },
        resetSearch() {
            this.searchKeyword = ''
            this.currentPage = 1
            this.getOrigins()
        },
        getOrigins(){
            const params = {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            if (this.searchKeyword) {
                params.keyword = this.searchKeyword
            }

            this.request.get('/namzar/admin/origins', { params }).then(res => {
                if (res.code === 200) {
                    const list = Array.isArray(res.data) ? res.data : []
                    this.originList = list.map(item => ({
                        id: item.id,
                        name: item.name || '',
                        created_at: item.created_at ? formatDateTime(item.created_at) : '',
                        updated_at: item.updated_at ? formatDateTime(item.updated_at) : '',
                    }))
                    // 处理分页信息
                    this.total = res.total || list.length
                } else {
                    this.$message.error(res.message || '获取数据失败')
                }
            }).catch(res => {
                this.$message.error(res?.message || '获取数据失败')
            })
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getOrigins()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getOrigins()
        },
        adding(){
            this.form = {
                name: ''
            }
            this.dialogFormVisible = true
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate()
                }
            })
        },
        editing(row){
            this.form = { 
                id: row.id,
                name: row.name
            }
            this.dialogFormVisible = true
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate()
                }
            })
        },
        editDone(){
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return false
                }
                
                const submitData = {
                    name: this.form.name
                }
                
                // 如果是编辑，需要包含id
                if (this.form.id) {
                    submitData.id = this.form.id
                    // 编辑接口
                    this.request.post('/namzar/admin/origins/edit', submitData).then(res => {
                        if (res.code === 200) {
                            this.$message.success(res.message || '更新成功')
                            this.dialogFormVisible = false
                            this.getOrigins()
                        } else {
                            this.$message.error(res.message || '更新失败')
                        }
                    }).catch(res => {
                        this.$message.error(res?.message || '更新失败')
                    })
                } else {
                    // 新增接口
                    this.request.post('/namzar/admin/origins/add', submitData).then(res => {
                        if (res.code === 200) {
                            this.$message.success(res.message || '添加成功')
                            this.dialogFormVisible = false
                            this.getOrigins()
                        } else {
                            this.$message.error(res.message || '添加失败')
                        }
                    }).catch(res => {
                        this.$message.error(res?.message || '添加失败')
                    })
                }
            })
        },
        editCancel(){
            this.dialogFormVisible = false
        },
        deleting(id){
            if (!id) {
                this.$message.error('缺少ID，无法删除')
                return
            }
            this.request.post('/namzar/admin/origins/delete', { id }).then(res => {
                if (res.code === 200) {
                    this.$message.success(res.message || '删除成功')
                    this.getOrigins()
                } else {
                    // 处理删除失败的情况，比如正在被使用
                    if (res.code === 400 && res.data && res.data.usage_count) {
                        this.$message.error(`无法删除：该origin正在被 ${res.data.usage_count} 个名字使用`)
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                }
            }).catch(res => {
                if (res.code === 400 && res.data && res.data.usage_count) {
                    this.$message.error(`无法删除：该origin正在被 ${res.data.usage_count} 个名字使用`)
                } else {
                    this.$message.error(res?.message || '删除失败')
                }
            })
        }
    },
}
</script>

<style scoped>
.origins-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100%;
}

.search-section {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
}

.table-container {
    background: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow-x: auto;
}

.custom-table {
    border-radius: 8px;
    overflow: hidden;
    min-width: 800px;
}

.custom-table ::v-deep .el-table__header-wrapper {
    background-color: #f5f7fa;
}

.custom-table ::v-deep .el-table__header th {
    background-color: #f5f7fa;
    color: #606266;
    font-weight: 600;
}

.ml-5 {
    margin-left: 5px;
}

.pagination-container {
    margin-top: 20px;
    text-align: center;
}

.pagination-container ::v-deep .el-pagination {
    white-space: nowrap;
    padding: 2px 5px;
    font-weight: 400;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
}
</style>

